/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette, shadows } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography, fontWeights } from '../../../styles/typography';

export const talktouscontentsholder = css({
  '.bottom_line': {
    borderBottom: '#D9DBDD solid 1px',
    paddingBottom: '50px',

    '.leftside_sec': {
      [MediaQueries.md]: {
        width: '44.5%',
        paddingRight: '0px',
      },
    },
  },
  h1: {
    fontSize: '40px',
    lineHeight: '48px',
    letterSpacing: '-0.30000001192092896px',
    textAlign: 'left',
    marginBottom: '40px',
    color: '#393939',
    fontWeight: '500',
    [MediaQueries.sm]: {
      fontSize: '34px',
      marginTop: '0px',
      marginBottom: '48px',
    },
  },

  '.backbutton': {
    marginTop: '0px',
    button: {
      background: 'transparent',
      border: '0',
      i: {
        position: 'relative',
        top: '2px',
      },
      '.backbuttontxt': {
        marginLeft: '10px',
      },
    },
  },
  '.leftsidearea': {
    display: 'flex',
    [MediaQueries.lg]: {
      flexDirection: 'column',
    },
    [MediaQueries.md]: {
      flexDirection: 'column',
    },
    [MediaQueries.sm]: {
      flexDirection: 'column',
    },
    '.left_side': {
      [MediaQueries.smAndUp]: {},
      [MediaQueries.lgAndUp]: {
        display: 'block',
      },

      [MediaQueries.lg]: {
        order: '2',
      },
      [MediaQueries.sm]: {
        order: '2',
      },

      '.img_1': {
        display: 'block',
        maxWidth: '177px',

        [MediaQueries.lg]: {
          display: 'none',
        },

        [MediaQueries.md]: {
          display: 'none',
        },
        [MediaQueries.sm]: {
          display: 'none',
        },
      },

      '.img_2': {
        display: 'none',
        maxWidth: '276px',
        marginTop: '54px',
        [MediaQueries.lg]: {
          display: 'block',
        },

        [MediaQueries.md]: {
          display: 'none',
        },
        [MediaQueries.sm]: {
          display: 'none',
        },
      },
    },
    '.needtotalktxt': {
      marginLeft: '44px',
      [MediaQueries.md]: {
        marginLeft: '0px',
      },
      [MediaQueries.lg]: {
        marginLeft: '0px',
        order: '1',
      },
      [MediaQueries.sm]: {
        marginLeft: '0px',
        order: '1',
      },
      h2: {
        fontSize: '22px',
        lineHeight: '32px',
        letterSpacing: '-0.004em',
        marginBottom: '16px',
        textAlign: 'left',
        color: '#393939',
        fontWeight: '500',
      },

      p: {
        fontSize: '16px',
        lineHeight: '24px',
        marginBottom: '16px',
        color: '#393939',
        fontWeight: '400',
        maxWidth: '304px',
        [MediaQueries.sm]: {
          marginBottom: '40px',
        },
      },

      '.callno': {
        display: 'flex',
        [MediaQueries.sm]: {
          marginBottom: '40px',
        },

        a: {
          textDecoration: 'none',
          color: '#393939',
          display: 'flex',
          alignItems: 'center',

          'span:first-child': {
            i: { fontSize: '22px', position: 'relative', top: '3px' },
          },

          '.numb': {
            fontSize: '33px',
            lineHeight: '40px',
            letterSpacing: '-0.003px',
            fontWeight: '300',
            color: '#393939',
            marginLeft: '18px',
            [MediaQueries.md]: {
              fontSize: '34px',
            },
            [MediaQueries.sm]: {
              fontSize: '28px',
            },
          },
        },
      },
    },
  },

  '.hrlinesec': {
    display: 'flex',
    justifyContent: 'center',
    [MediaQueries.md]: {
      maxWidth: '35px',
    },

    '.hrline': {
      width: '1px',
      height: '344px',
      backgroundColor: '#d9dbdd',
      [MediaQueries.sm]: {
        height: '1px',
        width: '100%',
        marginBottom: '40px',
        backgroundColor: '#d9dbdd',
      },

      [MediaQueries.lg]: {
        height: '344px',
      },
    },
  },

  '.formarea': {
    marginLeft: '4%',
    [MediaQueries.sm]: {
      marginLeft: '0%',
    },
    [MediaQueries.md]: {
      marginLeft: '0%',
      paddingLeft: '0px',
    },
    '.formtxt': {
      h2: {
        fontSize: '22px',
        lineHeight: '32px',
        letterSpacing: '-0.004em',
        marginBottom: '5px',
        textAlign: 'left',
        color: '#393939',
        fontWeight: '500',
      },

      p: {
        fontSize: '14px',
        lineHeight: '24px',
        marginBottom: '16px',
        color: '#393939',
        fontWeight: '400',
        maxWidth: '416px',
      },
    },

    '.contactform': {
      '.enquiry-input': {
        backgroundColor: colorsPalette.white,
        border: `1px solid ${colorsPalette.grey20}`,
        borderRadius: 2,
        color: colorsPalette.black,
        marginBottom: 16,
        height: 58,
        lineHeight: 1.67,
        padding: '0 16px',
        position: 'relative',
        WebkitAppearance: 'none',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        zIndex: 2,

        '::-webkit-input-placeholder': {
          color: colorsPalette.black,
        },
        ':-ms-input-placeholder': {
          color: colorsPalette.black,
        },
        '::placeholder': {
          color: colorsPalette.black,
        },

        ':focus': {
          outline: 0,
          borderColor: colorsPalette.white,
        },

        '::-ms-clear': {
          display: 'none',
        },

        '.countryflag': {
          position: 'relative',
          display: 'inline-block',
          marginRight: '12px',
        },
      },

      'button:hover': { background: '#d42705', outlineColor: '#d42705' },

      button: {
        alignItems: 'center',
        border: 'none',
        cursor: 'pointer',
        display: 'flex',
        justifyContent: 'center',
        background: '#d42705',
        outlineColor: '#d42705',
        borderRadius: '8px',
        height: '56px',
        minWidth: '100px',
        outline: 'none',
        padding: '0 24px',
        textAlign: 'center',
        textDecoration: 'none',
        width: ['100%', '100%'],
        fontSize: '14px',
        fontWeight: 500,
        lineHeight: 1.14,
        letterSpacing: ['0.87px', '1.6px'],
        textTransform: 'uppercase',
        color: '#ffffff',
        background: '#e52500',
        maxWidth: ['210px', 'none'],
        wordBreak: 'break-all',
        marginBottom: '0px',
      },
    },
    '.privacypolicytxt': {
      display: 'flex',
      marginTop: '20px',
      '.agreetxt': {
        display: 'inline-flex',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: 400,
        lineHeight: '24px',
        color: '#393939',
        letterSpacing: '0px',
        textAlign: 'left',
      },

      a: {
        top: '-2px',
        marginLeft: '10px',
        position: 'relative',

        fontWeight: 400,
        lineHeight: 1.78,
        cursor: 'pointer',
        display: 'block',
        padding: '0',
        textDecoration: 'none',
        color: '#e52500',

        fontSize: '14px',

        span: {
          borderBottom: '1px solid #fad3cc',
        },
      },
    },
  },
});
